import { createApp } from 'vue'
import Hermes from './Hermes.vue'
import router from './router'
import '@/assets/style.css'

createApp(Hermes)
	.use(router)
	.mount('#hermes')